import { render, staticRenderFns } from "./BillCompany.vue?vue&type=template&id=49d63f10&scoped=true"
import script from "./BillCompany.vue?vue&type=script&lang=js"
export * from "./BillCompany.vue?vue&type=script&lang=js"
import style0 from "./BillCompany.vue?vue&type=style&index=0&id=49d63f10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d63f10",
  null
  
)

export default component.exports